<template>
  <div class="account container">
    <div class="row">
      <loader v-if="isLoading"/>
      <div class="col-lg-12" v-if="!isLoading">
        <before-form-header title="Notification settings" description=""/>
        <div class="row">
          <div class="account-data col-12 col-md-8 col-lg-8 col-xl-8">
            <div class="row">
              <error class="col-12" :errors="errors"/>
              <div class="col-12" v-if="!dontShowCheckboxes">
                <div>
                  <div class="note">
                    Please choose here which notifications and news do you wish to subscribe to. We recommend that you stay subscribed to all to receive important information about your account,
                    news, and updates on Income Marketplace. We will not spam you and you can always change the settings here if you find some of the information to be irrelevant to you.
                  </div>
                  <loader v-show="notificationsUpdating"/>
                  <div class="notifications-list" v-if="!notificationsUpdating">
                    <ul>
                      <li>
                        <b-check v-model="subscriptionWeeklySummary" @change="updateSubscriptionInfo('WeeklySummary', $event)">
                          Weekly summary
                          <help-tooltip tooltipText="Weekly summary of your Income account for your information"></help-tooltip>
                        </b-check>
                      </li>
                      <li>
                        <b-check v-model="subscriptionMonthlySummary" @change="updateSubscriptionInfo('MonthlySummary', $event)">
                          Monthly summary
                          <help-tooltip tooltipText="Monthly summary of your Income account for your accounting records"></help-tooltip>
                        </b-check>
                      </li>
                      <li>
                        <b-check v-model="subscriptionDeposit" @change="updateSubscriptionInfo('Deposit', $event)">
                          Deposit
                          <help-tooltip tooltipText="Information about the funds you have added to your investor account"></help-tooltip>
                        </b-check>
                      </li>
                      <li>
                        <b-check v-model="subscriptionWithdrawal" @change="updateSubscriptionInfo('Withdrawal', $event)">
                          Withdrawal
                          <help-tooltip tooltipText="Confirmation when your withdrawal request has been successfully processed"></help-tooltip>
                        </b-check>
                      </li>
                      <li>
                        <b-check v-model="subscriptionBestResults" @change="updateSubscriptionInfo('BestResults', $event)">
                          Newsletters
                          <help-tooltip tooltipText="We`ll send you newsletters that allow you to stay up to date with the latest news on Income"></help-tooltip>
                        </b-check>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import BeforeFormHeader from '@/components/BeforeFormHeader'
import Error from '@/components/Error'
import Loader from '@/components/Loader'
import HelpTooltip from '@/components/HelpTooltip'
import investor from '@/api/investor'

export default {
  components: {HelpTooltip, Loader, Error, BeforeFormHeader},
  data()
  {
    return {
      investorDetails: this.$store.state.investors.investor,
      isLoading: true,
      subscriptionBestResults: false,
      subscriptionWeeklySummary: false,
      subscriptionMonthlySummary: false,
      subscriptionDeposit: false,
      subscriptionWithdrawal: false,
      notificationsUpdating: false,
      investorId: null,
      hash: null,
      errors: [],
      dontShowCheckboxes: false
    }
  },
  mounted()
  {
    this.isLoading = true
    if (this.$route.params && this.$route.params.id && this.$route.params.hash)
    {
      this.investorId = this.$route.params.id
      this.hash = this.$route.params.hash
      investor.getNotificationSettings(this.$route.params.id, this.$route.params.hash).then((response) =>
      {
        if (response)
        {
          // console.log(response)
          this.subscriptionBestResults = response.subscription_best_results
          this.subscriptionWeeklySummary = response.subscription_weekly_summary
          this.subscriptionMonthlySummary = response.subscription_monthly_summary
          this.subscriptionDeposit = response.subscription_deposit
          this.subscriptionWithdrawal = response.subscription_withdrawal

          this.isLoading = false
        }
      })
          .catch((error) =>
              {
                this.errors.push(error + ' ' + (error?.response?.data))
                this.$router.push({ name: 'Home' })
              }
          )
    }
  },
  methods: {
    async updateSubscriptionInfo(type, value)
    {
      this.notificationsUpdating = true
      // Additional update for test-server
      switch (type)
      {
        case 'WeeklySummary':
          this.subscriptionWeeklySummary = value
          break
        case 'MonthlySummary':
          this.subscriptionMonthlySummary = value
          break
        case 'Deposit':
          if (!value)
          {
            await this.$bvModal.msgBoxConfirm('By unsubscribing from Deposit emails you will not receive your deposit receipts by email instantly. You still can access it in your account. Are you sure?', {
              title: 'Please Confirm',
              size: 'md',
              buttonSize: 'sm',
              okVariant: 'warning',
              okTitle: 'Confirm',
              cancelTitle: 'Cancel',
              footerClass: 'p-1',
              hideHeaderClose: true,
              centered: true
            })
                .then(val =>
                {
                  if (val)
                  {
                    this.subscriptionDeposit = value
                  }
                  else
                  {
                    this.subscriptionDeposit = true
                    this.notificationsUpdating = false
                  }
                })
                .catch(err =>
                {
                  // An error occurred
                  console.log(err)
                })
            if (!this.notificationsUpdating)
            {
              return false
            }
          }
          else
          {
            this.subscriptionDeposit = value
          }
          break
        case 'Withdrawal':
          if (!value)
          {
            await this.$bvModal.msgBoxConfirm('By unsubscribing from Withdrawal emails you will not receive your Withdrawal receipts by email instantly. You still can access it in your account. Are you sure?', {
              title: 'Please Confirm',
              size: 'md',
              buttonSize: 'sm',
              okVariant: 'warning',
              okTitle: 'Confirm',
              cancelTitle: 'Cancel',
              footerClass: 'p-2',
              hideHeaderClose: true,
              centered: true
            })
                .then(val =>
                {
                  if (val)
                  {
                    this.subscriptionWithdrawal = value
                  }
                  else
                  {
                    this.subscriptionWithdrawal = true
                    this.notificationsUpdating = false
                  }
                })
                .catch(err =>
                {
                  // An error occurred
                  console.log(err)
                })
            if (!this.notificationsUpdating)
            {
              return false
            }
          }
          else
          {
            this.subscriptionWithdrawal = value
          }
          break
        case 'BestResults':
          this.subscriptionBestResults = value
          break
      }
      const data = {
        subscription_best_results: this.subscriptionBestResults,
        subscription_weekly_summary: this.subscriptionWeeklySummary,
        subscription_monthly_summary: this.subscriptionMonthlySummary,
        subscription_deposit: this.subscriptionDeposit,
        subscription_withdrawal: this.subscriptionWithdrawal
      }
      investor.setNotificationSettings(this.investorId, this.hash, data)
          .then(() =>
          {
            this.notificationsUpdating = false
          })
          .catch((error) =>
          {
            // console.error(error)
            this.errors.push(error)
            this.notificationsUpdating = false
          })
    }
  }
}
</script>

<style scoped lang="scss">
.notifications-list {
  ul {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      margin-top: 8px;
      margin-bottom: 8px;
    }
  }
}
</style>
